module.exports = __webpack_public_path__ + "static/media/BG1.9fdf2c23.png";